import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-icon-button',
  standalone: true,
  imports: [
    SvgIconComponent
  ],
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss'
})
export class IconButtonComponent {
  @Input() path: string = '';
  @Input() readonly: boolean = false;
  @Output() clicked = new EventEmitter<void>();

  handleClick(event: Event) {
    if (!this.readonly) {
      this.clicked.emit();
    }
  }
}
